export enum urlDataActionTypes {
    SetUrlDataType = "SET_URLDATA",
}

export const setUrlData = (data: any) => ({
    type: urlDataActionTypes.SetUrlDataType,
    payload: data
});
